export const INVALID_DOMAIN_MESSAGE = 'Must have the same domain as that of billing account';
